module.exports = __webpack_public_path__ + "static/media/piano_annuale_maratona.623d8cbd.jpg";